import styled from 'styled-components'

export const ProfileStyle = styled.div`
  width: 100%;
  .placeholder {
    height: 400px;
  }
`

export const ProfileContainer = styled.div`
  min-height: calc(100vh - 150px);
  width: 100%;
  padding: 0 20px 20px 20px;
  text-align: left;
  color: rgb(210, 210, 210);
  position: relative;
  z-index: 2;

  .content-container {
    border-radius: 15px;
    background-color: rgba(0, 0, 0, 0.85);

    @media only screen and (max-width: 600px) {
      margin-top: 20px;
    }
  }

  .profile-image {
    max-width: 100%;
    border-radius: 20px;
    max-height: 300px;
    object-fit: cover;

    @media only screen and (max-width: 600px) {
      margin-bottom: 20px;
      object-fit: cover;
    }
  }

  .content {
    display: flex;
    flex-direction: row;
    align-items: stretch;
  }

  h3 {
    color: rgb(82, 171, 214);
    font-weight: 700;
  }

  .profile-designation {
    font-weight: 800;
    font-size: 0.85em;
  }

  .profile-country {
    font-size: 0.85em;
  }

  .social-links {
    gap: 20px;

    a {
      font-weight: 600;
      color: rgb(210, 210, 210);
    }
  }

  .profile-instagram {
    svg {
      height: 20px !important;
      width: 20px !important;
    }
  }

  .icon {
    margin-right: 10px;

    svg {
      height: 18px;
    }
  }

  label {
    font-size: 0.8em;
    font-weight: 600;
  }

  input {
    background: none;
    outline: none;
    border: 1px solid rgb(100, 100, 100);
    padding: 8px;
    border-radius: 10px;
    color: rgb(210, 210, 210);
    font-size: 0.9em;
    width: 50%;

    @media only screen and (max-width: 600px) {
      width: 100%;
    }
  }

  input::placeholder {
    font-size: 0.9em;
    color: rgb(210, 210, 210);
  }

  textarea {
    background: none;
    padding: 8px;
    border-radius: 10px;
    color: rgb(210, 210, 210);
    font-size: 0.9em;
  }

  textarea::placeholder {
    font-size: 0.9em;
    color: rgb(210, 210, 210);
  }

  .country-dropdown {
    width: 100%;
    border: 1px solid rgb(100, 100, 100);
    padding: 8px;
    border-radius: 10px;
    font-size: 0.9em;
  }

  .country-container {
    position: relative;
  }

  .country-list {
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    margin-top: 20px;
    border: 1px solid rgb(100, 100, 100);
    padding: 8px;
    border-radius: 10px;
    font-size: 0.9em;
    max-height: 300px;
    overflow-y: scroll;
    background-color: black;
    z-index: 2;
  }

  .country-option {
    cursor: pointer;
  }

  .country-option:hover {
    font-weight: 800;
    cursor: pointer;
  }

  .profile-submit {
    margin-top: 50px;
    border: none;
    padding: 8px 15px 8px 15px;
    border-radius: 10px;
    text-transform: uppercase;
    font-weight: 700;
    color: white;
    background-color: var(--bs-danger);

    @media only screen and (max-width: 600px) {
      display: block;
      margin: 0 auto;
      margin-top: 0px;
    }
  }
`
